import { render, staticRenderFns } from "./detailDownload.vue?vue&type=template&id=7a27a854&scoped=true"
import script from "./detailDownload.vue?vue&type=script&lang=js"
export * from "./detailDownload.vue?vue&type=script&lang=js"
import style0 from "./detailDownload.vue?vue&type=style&index=0&id=7a27a854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a27a854",
  null
  
)

export default component.exports